import ActionButton from "../formInputs/buttons/ActionButton";
import T from "../translations/Translations";

import { GUARDIAN_DASHBOARD } from "../../utils/auth/config";

import "../../styles/SaveBlock.scss";

/**
 * A Save block with only one button: "Back to Dashboard"
 * @name BackOnly
 * @returns {JSX.Element}
 */
const BackOnly = () => {
    return (
        <div className="save-block-container back-only">
            <div className="save-button-container">
                <a href={GUARDIAN_DASHBOARD}>
                    <ActionButton
                        label={T({ key: "OE_Buttons_Back_To_Dashboard" })}
                        onClick={() => {
                            sessionStorage.clear();
                            return true;
                        }}
                    />
                </a>
            </div>
        </div>
    );
};

export default BackOnly;
